import { IAnalyticSdr } from '../../../types/analyticsSdr';

/**
 * Analytics SDR for Policy Manager Domain.
 * This information should match the values in the SDR Excel file referenced here:
 * https://chalk.charter.com/display/ERSPM/FE+Analytics
 */

const siteSection = 'Policy Manager';

export const policyMgrAnalytics: IAnalyticSdr = {
  policyManager: {
    siteSection,
    buttonClicks: {
      createAccessPolicyBtn: {
        itemClicked: 'Create Access Policy',
      },
      editAccessPolicyMenuBtn: {
        itemClicked: 'Edit Access Policy',
      },
      deleteAccessPolicyMenuOpenBtn: {
        itemClicked: 'Delete Access Policy Menu',
      },
      deleteAPModalDeleteBtn: {
        itemClicked: 'Delete',
      },
      deleteAPModalCancelBtn: {
        itemClicked: 'Cancel',
      },
      deleteAPModalCloseBtn: {
        itemClicked: 'Close',
      },
      deleteAccessPolicySuccess: {
        itemClicked: 'Delete Success',
      },
      deleteAccessPolicyErr: {
        itemClicked: 'Delete Error',
      },
    },
    menuSelections: {
      capabilitiesMenu: {
        itemClicked: 'All Capabilities',
      },
    },
  },
  createAccessPolicy: {
    siteSection,
    siteSubSection: 'Create Policy',
    buttonClicks: {
      createBackBtn: {
        itemClicked: 'Back',
      },
      createContinueBtn: {
        itemClicked: 'Continue',
      },
      createContinueBtnErr: {
        itemClicked: 'Continue with Error',
      },
      createCancelBtn: {
        itemClicked: 'Cancel',
      },
      createSaveBtn: {
        itemClicked: 'Save',
      },
      createSaveBtnErr: {
        itemClicked: 'Save with Error',
      },
      createCloseBtn: {
        itemClicked: 'Close',
      },
      internalUserRadioBtn: {
        itemClicked: 'Internal',
      },
      externalUserRadioBtn: {
        itemClicked: 'External',
      },
    },
  },
  editAccessPolicy: {
    siteSection,
    siteSubSection: 'Edit Policy',
    buttonClicks: {
      editBackBtn: {
        itemClicked: 'Back',
      },
      editContinueBtn: {
        itemClicked: 'Continue',
      },
      editContinueBtnErr: {
        itemClicked: 'Continue with Error',
      },
      editCancelBtn: {
        itemClicked: 'Cancel',
      },
      editSaveBtn: {
        itemClicked: 'Save',
      },
      editSaveBtnErr: {
        itemClicked: 'Save with Error',
      },
      editCloseBtn: {
        itemClicked: 'Close',
      },
    },
  },
};
